import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-programs',
    templateUrl: './programs.component.html'
})
export class ProgramsComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Mit teszünk?', instructions: ['/mit-teszunk']}).add({name: 'Programok'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/programs/programs.component.ts